import type { TourSection } from './types';

export const aiConfigsListSections: TourSection[] = [
  {
    id: 'overview',
    label: 'Qué son las configuraciones IA',
    steps: [
      {
        target: '[data-tour="ai-configs-header"]',
        title: 'Configuraciones de IA',
        content:
          'Cada configuración define cómo la IA genera UN atributo de los productos (qué modelo usa, qué instrucción le da, qué datos lee del producto). Se aplican según la categoría del producto: si no hay una específica, se usa la de las categorías superiores o la global.',
      },
    ],
  },
  {
    id: 'filters',
    label: 'Filtros',
    steps: [
      {
        target: '[data-tour="ai-configs-filters"]',
        title: 'Filtros del listado',
        content:
          'Filtra por atributo, categoría o si está activa. El listado solo muestra las configuraciones cargadas — la herencia entre categorías ocurre cuando el sistema genera la sugerencia.',
      },
    ],
  },
  {
    id: 'create',
    label: 'Crear nueva configuración',
    steps: [
      {
        target: '[data-tour="ai-configs-new"]',
        title: 'Nueva configuración',
        content:
          'Crea una configuración para un atributo + categoría. Si ya existe esa combinación, el botón Crear fallará — edita la existente desde la tabla.',
      },
    ],
  },
];
